import { Button, tokens } from "@manifesthhqinc/ui-library";
import { HeadlineMedium, Highlight, BodyLargeBold } from "../../../components/font";
import Footer from "../../../components/footer";
import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";
import Container from "../../../layout/container";
import ScrollableContainer from "../../../layout/scrollable-container";
import { UseExploreIRAOptionsType } from "../useExploreIRAOptions";
import { Dot, IRAFeatureList, IRAFeatureListItem, IRAProviderLogoDiv } from "./styles";
import HeadingContainer from "../../../layout/heading-container";

const ExploreIRAOptionResult = (props: UseExploreIRAOptionsType) => {
  const { iraRecommendationContent, onClickContinue } = props;
  return (
    <TransitionWrapper>
      <ScrollableContainer name="explore-ira-result">
        <Container>
          <HeadingContainer paneVariant="form" withProgressBar>
            <HeadlineMedium $textAlign="center">
              Here’s your best match:
              <br />
              <Highlight>{iraRecommendationContent?.FIRST.providerName} IRA</Highlight>
            </HeadlineMedium>
          </HeadingContainer>
          <IRAProviderLogoDiv>
            <img src={iraRecommendationContent?.FIRST.logo} alt={iraRecommendationContent?.FIRST.providerName} />
          </IRAProviderLogoDiv>
          <IRAFeatureList>
            <IRAFeatureListItem>
              <Dot />
              <BodyLargeBold $color={tokens.color.text[1000]}>Best match with your investment style</BodyLargeBold>
            </IRAFeatureListItem>
            <IRAFeatureListItem>
              <Dot />
              <BodyLargeBold $color={tokens.color.text[1000]}>98% match with your priorities</BodyLargeBold>
            </IRAFeatureListItem>
            <IRAFeatureListItem>
              <Dot />
              <BodyLargeBold $color={tokens.color.text[1000]}>Offers the features you value</BodyLargeBold>
            </IRAFeatureListItem>
          </IRAFeatureList>
        </Container>
      </ScrollableContainer>
      <Footer>
        <Button name="continue" onClick={() => onClickContinue()} size="large">
          Continue
        </Button>
      </Footer>
    </TransitionWrapper>
  );
};

export default ExploreIRAOptionResult;
